import { SVGProps } from 'react'

export const ReportIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="27"
    viewBox="0 0 24 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_732_11915"
      style={{ maskType: 'luminance' }} // ✅ fixed
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="27"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.5 0.181641H23.2362V26.653H0.5V0.181641Z"
        fill="white"
      />
    </mask>

    <g mask="url(#mask0_732_11915)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.59742 2.18164C4.38809 2.18164 2.55342 3.97097 2.50142 6.17764V20.4696C2.45342 22.7376 4.24009 24.6043 6.48676 24.6536H17.2641C19.4894 24.5736 21.2508 22.7376 21.2361 20.4763V8.61897L15.0574 2.18164H6.61342H6.59742ZM6.61342 26.6536H6.44542C3.09609 26.5816 0.429424 23.7976 0.501424 20.4483V6.15364C0.580091 2.84564 3.31076 0.181641 6.59342 0.181641H6.61742H15.4828C15.7548 0.181641 16.0148 0.292307 16.2041 0.488307L22.9588 7.52431C23.1361 7.70964 23.2361 7.95897 23.2361 8.21631V20.4696C23.2574 23.815 20.6494 26.5336 17.2988 26.6536H6.61342Z"
        fill="#27272A"
      />
    </g>

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3555 19.7666C10.8035 19.7666 10.3555 19.3186 10.3555 18.7666V10.7119C10.3555 10.1599 10.8035 9.71191 11.3555 9.71191C11.9075 9.71191 12.3555 10.1599 12.3555 10.7119V18.7666C12.3555 19.3186 11.9075 19.7666 11.3555 19.7666Z"
      fill="#27272A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.23014 14.8523C7.97547 14.8523 7.71947 14.755 7.52481 14.5603C7.13414 14.171 7.13147 13.539 7.52214 13.147L10.6475 10.0057C11.0235 9.62832 11.6901 9.62832 12.0648 10.0057L15.1928 13.147C15.5821 13.539 15.5808 14.171 15.1901 14.5603C14.7981 14.9497 14.1648 14.9497 13.7755 14.5577L11.3568 12.1283L8.93814 14.5577C8.74347 14.755 8.48614 14.8523 8.23014 14.8523Z"
      fill="#27272A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.2288 9.47899H18.5568C16.1155 9.47233 14.1328 7.48299 14.1328 5.04566V1.16699C14.1328 0.614992 14.5808 0.166992 15.1328 0.166992C15.6848 0.166992 16.1328 0.614992 16.1328 1.16699V5.04566C16.1328 6.38433 17.2208 7.47499 18.5595 7.47899H22.2288C22.7808 7.47899 23.2288 7.92699 23.2288 8.47899C23.2288 9.03099 22.7808 9.47899 22.2288 9.47899Z"
      fill="#27272A"
    />
  </svg>
)
